import React, { useCallback, useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import ModalHeader from 'react-bootstrap/ModalHeader'
import ModalBody from 'react-bootstrap/ModalBody'
import ModalFooter from 'react-bootstrap/ModalFooter'
import FormGroup from 'react-bootstrap/FormGroup'
import FormControl from 'react-bootstrap/FormControl'
import FormLabel from 'react-bootstrap/FormLabel'
import { NewUserModalProps } from './types'

export const NewUserModal = (props: NewUserModalProps) => {
    const { isVisible, toggle, create } = props
    const [login, setLogin] = useState<string>('')
    const [level, setLevel] = useState<number>(1)

    useEffect(() => {
        setLogin('')
        setLevel(1)
    }, [])

    const onClose = useCallback(() => {
        setLogin('')
        setLevel(1)
        toggle()
    }, [setLogin, setLevel, toggle])

    return (
        <Modal show={isVisible} onHide={onClose} style={{ zIndex: '9000' }}>
            <ModalHeader>Register new user</ModalHeader>
            <ModalBody>
                <FormGroup className="mb-3">
                    <FormLabel>Login</FormLabel>
                    <FormControl
                        placeholder="User login (at least 3 characters)"
                        value={login}
                        onChange={e => setLogin(e.target.value)}
                    />
                </FormGroup>
                <FormGroup className="mb-3">
                    <FormLabel>Level</FormLabel>
                    <FormControl
                        disabled={true}
                        type="number"
                        placeholder="1"
                        value={level}
                        onChange={e =>
                            setLevel(Number.parseInt(e.target.value))
                        }
                    />
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button
                    disabled={login.length < 3}
                    variant="success"
                    onClick={() => {
                        toggle()
                        create(login, level)
                    }}>
                    Create
                </Button>
            </ModalFooter>
        </Modal>
    )
}
